// npm
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// react
import { Popup } from "components/layout/popup";
import { CancelButton } from "./buttons/cancel";
import { ConfirmButton } from "./buttons/confirm";
import { withMessages } from "components/hocs/messages";

// redux (selectors)
import { getExamData } from "redux/reducers/selectors";
import { getContentData } from "redux/reducers/exam/selectors";
import { getQuestionsData } from "redux/reducers/exam/content/selectors";
import { getType } from "redux/reducers/exam/content/questions/question/selectors";

// constants
import { MESSAGE_IDS } from "constants/message-ids";
import { ICT } from "constants/question-types";
import { isValidMessage } from "utils/message-helper";

const finishConfirmTitle1 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_TITLE_1;
const finishConfirm1 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_INFO_1;
const finishConfirmUpload = MESSAGE_IDS.EXAM.FINISH_CONFIRM_INFO_1_UPLOAD;

class ExamFinishConfirmPopup extends Component {
    render() {
        const { onClose, onConfirm, messages, hasUploadQuestion } = this.props;

        const contentMessageId =
            hasUploadQuestion && isValidMessage(messages[finishConfirmUpload])
                ? finishConfirmUpload
                : finishConfirm1;

        const props = {
            title: messages[finishConfirmTitle1],
            content: { text: messages[contentMessageId] },
            buttons: [
                <ConfirmButton onClick={onConfirm} />,
                <CancelButton onClick={onClose} />,
            ],
            onClose,
        };

        return <Popup {...props} />;
    }
}

ExamFinishConfirmPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    messages: PropTypes.shape({
        [finishConfirmTitle1]: PropTypes.string.isRequired,
        [finishConfirm1]: PropTypes.string.isRequired,
    }).isRequired,
};

ExamFinishConfirmPopup = withMessages(ExamFinishConfirmPopup);

const mapStoreToProps = (store) => {
    const examData = getExamData(store);
    const contentData = getContentData(examData);
    const questionsData = getQuestionsData(contentData);
    const hasUploadQuestion = questionsData.some(
        (questionData) => getType(questionData) === ICT,
    );

    return { hasUploadQuestion };
};

ExamFinishConfirmPopup = connect(mapStoreToProps)(ExamFinishConfirmPopup);

export { ExamFinishConfirmPopup };
